import type { Trade } from "../types/trade";

/** Read `asset_class` from a trade row (frontend or backend / snapshot shape). */
export function readTradeAssetClass(trade: unknown): string | undefined {
  if (!trade || typeof trade !== "object") return undefined;
  const o = trade as Record<string, unknown>;
  const raw = o.asset_class ?? o.assetClass;
  if (typeof raw === "string" && raw.trim()) return raw.trim().toLowerCase();
  return undefined;
}

/** Prefer focus trade, then any trade in the cohort for the active symbol. */
export function pickAssetClassFromTrades(
  trades: Trade[],
  focusTradeId?: string | null
): string | undefined {
  if (focusTradeId) {
    const focused = trades.find((t) => t.id === focusTradeId);
    const fromFocus = readTradeAssetClass(focused);
    if (fromFocus) return fromFocus;
  }
  for (const t of trades) {
    const ac = readTradeAssetClass(t);
    if (ac) return ac;
  }
  return undefined;
}
